import { Box, Divider, Stack, Theme, Typography } from '@mui/material';
import axios from 'axios';
import { filter } from 'lodash';
import * as React from 'react';
import Select from 'react-select';
import keycloak from '../../keycloak';
import { checkRole, IUser, setAIGenerateEnable } from '../../stores/jotai/base';
import IwSwitch from './IwSwitch';
import { ADMIN_VALID_EMAIL } from '../../constants';


// Menu items
// The order listed is the order they should render (I realize JSON doesn't gauarantee
// order, but untill it's a problem whatever)

const MENU_CONFIG = [ 
// {
//     value: 'license-manager',
//     label: 'License Manager',
//     roles: 'system_admin'
// }
// , {
//     value: 'user-search',
//     label: "User Search",
//     roles: "system_admin"
// },
{
    value: "profile",
    label: "Profile",
    roles: "*"
}, 
{
    value: "signout",
    label: "Sign Out",
    roles: "*"
},
];

interface IProps {
    handleAction: (slug: string) => void;
    group: any;
    avatar: JSX.Element;
    user: IUser;
    org: OrgState;
    team: any;
    cohort: any;
    app: AppState;
    base: any;
    setBase: any;
    theme?: Theme;
}

interface Refs {
  [key: string]: React.Component<any, any>;
  periodDropdown: Select;
}

interface IState {
  isMenuOpen: boolean;
}

export class SettingsDropdown extends React.Component<IProps, IState> {
  state: IState = {
    isMenuOpen: false,
  };
  refs: Refs;

  componentDidMount() {
    (typeof window !== "undefined" ? document : {}).addEventListener(
      "keydown",
      this.handleEscapePress,
      false
    );
    const isSystemAdministrator = checkRole( this.props.base, "isSystemAdministrator" ) && ADMIN_VALID_EMAIL.includes(this.props.base?.user?.email);
    if(isSystemAdministrator){
        MENU_CONFIG.push(
        {
          value: "admin",
          label: "System Management",
          roles: "isSystemAdministrator" 
        }, 
      )
    }
  }

  componentWillUnmount() {
    (typeof window !== "undefined" ? document : {}).removeEventListener(
      "keydown",
      this.handleEscapePress,
      false
    );
  }



  handleEscapePress = (event) => {
    if (event.keyCode === 27) {
      this.setState({
        isMenuOpen: false
      });
    }
  };

  checkItemValidity = (menuItem: any) => {
    const { user, org } = this.props;

    const isInstructor = checkRole(this.props.base, "isInstructor");
    const notTeamMemberOrAdmin =
      !checkRole(this.props.base, "isTeamMember") &&
      !checkRole(this.props.base, "isCohortAdmin");
    const hideOptionalFeatures = isInstructor && notTeamMemberOrAdmin;
    const isInstructorOrCA =
      checkRole(this.props.base, "isInstructor") ||
      checkRole(this.props.base, "isCohortAdmin");
    const isSystemAdministrator = checkRole(
      this.props.base,
      "isSystemAdministrator"
    ) && ADMIN_VALID_EMAIL.includes(this.props.base?.user?.email);
    const isNormalAdmin = checkRole(this.props.base, "isAdmin");

    if (menuItem.roles === "*") {
      return true;
    }

    const isRoleOpposite = menuItem.roles.includes("!");
    const cleanedRole = menuItem.roles.replace("!", "");

    // option: let SA's blindly see everything
    if (isSystemAdministrator) {
      return true;
    }

    if (cleanedRole === "system_admin") {
      // option: still use opposite roles but apply SA otherwise
      if (isRoleOpposite && isSystemAdministrator === false) {
        return true;
      }

      if (isRoleOpposite === false && isSystemAdministrator) {
        return true;
      }
    }

    if (cleanedRole === "admin") {
      if (isRoleOpposite && isNormalAdmin === false) {
        return true;
      }

      if (isRoleOpposite === false && isNormalAdmin) {
        return true;
      }
    }

    if (cleanedRole === "instructor") {
      if (isRoleOpposite && isInstructor === false) {
        return true;
      }

      if (isRoleOpposite === false && isInstructor) {
        return true;
      }
    }

    return false;
  };

  getOptions = () => {
    const items = filter(MENU_CONFIG, (potentitalMenuItem) => {
      return this.checkItemValidity(potentitalMenuItem);
    });

    return items;
  };

  toggleOpen = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  };

  calculateClassName = () => {
    return "react-select-dd";
  };

  calculateMenuProvider = (provided) => {
    const { theme } = this.props;
    return {
      ...provided,
      position: "absolute",
      width: "270px",
      right: 0,
      zIndex: theme.custom.menuZIndex,
      boxShadow: theme.custom.menuBoxShadow,
      marginTop: "0",
      borderRadius: "4px",
      overflow: "hidden"
    };
  };

  calculateControlProvider = (provided, state) => {
    return {
      ...provided,
      border: "none",
      backgroundColor: "transparency",
      outline: "none",
      position: "relative",
      boxShadow: "none",
      paddingTop: "0px",
      marginLeft: "6px",
      paddingBottom: "0px"
    };
  };

  calculateStyleProvider = (provided, state) => {
    const { theme } = this.props;
    return {
      ...provided,
      color: "black",
      backgroundColor: "white",
      cursor: "pointer",
      width: "100%",
      position: "static",
      lineHeight: "20px",
      padding: "10px 16px",
      "&:hover": {
        backgroundColor: theme.custom.hoverOptionColor
      }
    };
  };

  calculateValueContainer = (provided, state) => {
    return {
      ...provided,
      padding: "0px"
    };
  };

  renderInput = (innerProps) => {
    const { avatar } = this.props;

    return (
      <span
        style={{ cursor: "pointer" }}
        onTouchStart={() => {
          this.toggleOpen();
        }}
        onClick={() => {
          this.toggleOpen();
        }}
      >
        {avatar}
      </span>
    );
  };

  renderPlaceholder = (innerProps) => {
    return <span></span>;
  };

  renderDropdownIndicator = (innerProps) => {
    return (
      <span
        onClick={() => {
          this.toggleOpen();
        }}
        style={{}}
      ></span>
    );
  };

  renderInfoTable = (data) => {
    const infoTableFontWeight = 600;
    const infoTableFontSize = "15px";
    const { theme } = this.props;
    let rows = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i] === "divider") {
        rows.push(<Divider sx={{ margin: "6px 0" }} />);
      } else {
        rows.push(
          <Stack direction="row">
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: infoTableFontSize,
                color: theme.custom.grayLabelText
              }}
            >
              {data[i][0]}:
            </Typography>
            <Typography
              sx={{
                fontWeight: infoTableFontWeight,
                fontSize: infoTableFontSize,
                marginLeft: "6px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden"
              }}
            >
              {data[i][1]}
            </Typography>
          </Stack>
        );
      }
    }

    return rows;
  };





  renderMenuList = (innerProps) => {
    return (
      <Stack sx={{ borderRadius: "4px" }} direction="column">
        {innerProps.children}
      </Stack>
    );
  };
  render() {
    const { isMenuOpen } = this.state;
    const { theme } = this.props;
    const styleProvider = {
      option: this.calculateStyleProvider,
      control: this.calculateControlProvider,
      menu: this.calculateMenuProvider,
      valueContainer: this.calculateValueContainer
    };

    const componentOverrides = {
      Input: this.renderInput,
      Placeholder: this.renderPlaceholder,
      DropdownIndicator: this.renderDropdownIndicator,
      SingleValue: this.renderPlaceholder,
      IndicatorSeparator: this.renderPlaceholder,
      MenuList: this.renderMenuList
    };

    const clickAwayTracker = (
      <span
        onClick={(e) => {
          this.setState({
            isMenuOpen: false
          });
        }}
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          height: "100vh",
          width: "100vw",
          zIndex: theme.custom.menuClickAwayZIndex
        }}
      />
    );

    // return <span style={{display: 'block', position: 'relative', width: '30px', top: '6px', left: '-11px'}}>
    {
      /* <span className="userSettingsDropdownInc"><Icon >arrow_drop_down</Icon></span> */
    }
    return (
      <span style={{ position: "relative" }}>
        {isMenuOpen ? clickAwayTracker : undefined}
        <Select
          menuIsOpen={isMenuOpen}
          components={componentOverrides}
          selected={undefined}
          className={this.calculateClassName()}
          styles={styleProvider}
          options={this.getOptions()}
          openMenuOnFocus={true}
          onChange={(options: any) => {
            this.props.handleAction(options.value);

            this.toggleOpen();
          }}
        />
      </span>
    );
  }
}
